<template>
  <v-col class="pa-0 container" v-if="!isOwner">
    <v-row class="ma-0 checkbox-title" justify="end">
      <div class="mx-2">Viewer</div>
      <div class="mx-2">Admin</div>
    </v-row>
    <v-row class="ma-0">
      <v-list class="pt-0" style="width: 100%">
        <v-list-item v-for="(item, idx) in accessRoles" :key="idx" class="px-0">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="mx-5">
            <v-checkbox
              v-if="roleHasSelectedParentDependency(item.adminRole)"
              v-model="selectedRoles"
              :value="getRoleParentDependency(item.adminRole)"
              :disabled="true"
            ></v-checkbox>
            <v-checkbox
              v-else-if="roleHasSelectedParentDependency(item.viewerRole)"
              v-model="selectedRoles"
              :value="getRoleParentDependency(item.viewerRole)"
              :disabled="true"
            ></v-checkbox>
            <v-checkbox
              v-else-if="selectedRoles.includes(item.adminRole)"
              v-model="selectedRoles"
              :value="item.adminRole"
              :disabled="selectedRoles.includes(item.adminRole)"
            ></v-checkbox>
            <v-checkbox
              v-else
              v-model="selectedRoles"
              :value="item.viewerRole"
              :disabled="roleHasSelectedParentDependency(item.viewerRole)"
            ></v-checkbox>
          </v-list-item-action>
          <v-list-item-action class="mx-5">
            <v-checkbox
              v-if="roleHasSelectedParentDependency(item.adminRole)"
              v-model="selectedRoles"
              :value="getRoleParentDependency(item.adminRole)"
              :disabled="true"
            ></v-checkbox>
            <v-checkbox
              v-else
              v-model="selectedRoles"
              :value="item.adminRole"
              :disabled="roleHasSelectedParentDependency(item.adminRole)"
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-row>
  </v-col>
  <div v-else><v-chip>Owner</v-chip></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data: () => ({
    selectedRoles: [],
  }),
  mounted() {
    this.selectedRoles =
      this.value?.map((userRole) => {
        let rolePath = typeof userRole === 'string' ? userRole : userRole.path
        return this.companyRoles.find((cRole) => cRole.ref.path === rolePath)
      }) ?? []
  },
  computed: {
    ...mapGetters(['activeSubscription', 'companyRoles', 'clickworkProducts']),
    accessRoles() {
      return (
        this.activeSubscription?.products
          .map((prodRef) => {
            return {
              ...this.productForSubscription(prodRef),
              adminRole: this.adminRoleForSubscription(prodRef),
              viewerRole: this.viewerRoleForSubscription(prodRef),
            }
          })
          .sort((a, b) => {
            if (a.listOrder > b.listOrder) {
              return 1
            } else if (a.listOrder < b.listOrder) {
              return -1
            }
            return 0
          }) ?? []
      )
    },
    isOwner() {
      const ownerRole = this.selectedRoles.find(
        (r) => r.name === 'company-owner'
      )
      return ownerRole !== undefined
    },
  },
  methods: {
    productForSubscription(productRef) {
      return this.clickworkProducts.filter((pr) => {
        return pr.productPath === productRef.path
      })[0]
    },
    adminRoleForSubscription(prodRef) {
      return this.adminRoleForProduct(this.productForSubscription(prodRef))
    },
    viewerRoleForSubscription(prodRef) {
      return this.viewerRoleForProduct(this.productForSubscription(prodRef))
    },
    adminRoleForProduct(product) {
      return this.rolesForProduct(product).filter(
        (role) => role.name === 'product-admin'
      )[0]
    },
    viewerRoleForProduct(product) {
      return this.rolesForProduct(product).filter(
        (role) => role.name === 'product-user'
      )[0]
    },
    rolesForProduct(product) {
      return this.companyRoles.filter(
        (role) =>
          role.productRef && role.productRef?.path === product.productPath
      )
    },
    roleHasSelectedParentDependency(role) {
      return this.getRoleParentDependency(role) !== undefined
    },
    getRoleParentDependency(role) {
      for (let sRole of this.selectedRoles) {
        if (
          sRole.dependencyRoles
            ?.map((r) => r.path)
            .includes(role.defaultRoleRef.path)
        ) {
          return sRole
        }
      }
      return undefined
    },
    getDependencyRoles(mainRole) {
      const roles = []
      if (mainRole.dependencyRoles) {
        mainRole.dependencyRoles.forEach((depRoleRef) => {
          const role = this.companyRoles.filter(
            (role) =>
              role.defaultRoleRef &&
              role.defaultRoleRef.path === depRoleRef.path
          )[0]
          if (role) {
            roles.push(role)
          }
        })
      }
      return roles
    },
  },
  watch: {
    selectedRoles: {
      handler: function (newValue) {
        const roles = []
        roles.push(...newValue.map((role) => role.ref.path))

        newValue.forEach((role) => {
          const deps = this.getDependencyRoles(role)
          roles.push(...deps.map((r) => r.ref.path))
        })

        this.$emit('input', roles)
      },
      deep: true,
    },
  },
}
</script>

<style lang="sass" scoped>
.container
  max-width: 240px !important
  margin: 0

.checkbox-title
  @include body_dark
</style>